export function tabsLeft() {

    $('.section-tabs-left').on('click', '.menu-item', function () {
        var _tabs_id = $(this).parent().data('tabs');

        if ( !$(this).hasClass("current-menu-item") ) {
            $(this).siblings('.menu-item').removeClass('current-menu-item');
            $(this).addClass('current-menu-item');
            var _id =  $(this).data('id');
            $(this).parent().parent().siblings('.tabs-body').find('.tab-content').removeClass('current');
            $('#' + _tabs_id + '-tab-' + _id).addClass('current');
        }
    });

}



// WEBPACK FOOTER //
// ./assets/js/modules/tabs-left.js